module.exports = __webpack_public_path__ + "static/about-content-image-3@2x-f2f7c32d67c626087b51ae5920b2d06e.jpg";